export const VARIANT_SHIP_SPRITES: Record<string, string> = {
  sparrow_mk1: 'sparrow_mk1',
  sparrow_mk2: 'sparrow_mk2',
  nighthawk: 'nighthawk',
  eclipse: 'eclipse',
  wraith_mk1: 'wraith_mk1',
  wraith_mk2: 'wraith_mk2',
  phantom: 'phantom',
  valkyrie: 'valkyrie',
  corsair_mk1: 'corsair_mk1',
  corsair_mk2: 'corsair_mk2',
  reaper: 'reaper',
  sentinel: 'sentinel',
};

export const CLASS_SHIP_SPRITES: Record<string, string> = {
  scout: 'scout',
  fighter: 'fighter',
  cruiser: 'cruiser',
  bomber: 'bomber',
  carrier: 'carrier',
  battleship: 'battleship',
  destroyer: 'destroyer',
  titan: 'titan',
  dreadnought: 'dreadnaught',
  dreadnaught: 'dreadnaught',
  trade_ship: 'tug',
  space_tug: 'tug',
};

export function getVariantSpriteKey(variantId?: string | null): string | null {
  if (!variantId) return null;
  return VARIANT_SHIP_SPRITES[variantId] || null;
}

export function getShipSpriteKey(shipClass: string, variantId?: string | null): string | null {
  return getVariantSpriteKey(variantId) || CLASS_SHIP_SPRITES[shipClass] || null;
}
